import { createRouter, createWebHistory } from 'vue-router';

import HomeView from '@/views/HomeView.vue';
import QuemSomosView from '@/views/QuemSomosView.vue';
import ExamesView from '@/views/ExamesView.vue';
import EventosView from '@/views/EventosView.vue';
import BlogView from '@/views/BlogView.vue';
import ArtigosView from '@/views/ArtigosView.vue';
import GaleriaView from '@/views/GaleriaView.vue';
import ContatoView from '@/views/ContatoView.vue';
import ExameDetalheView from '@/views/ExameDetalheView.vue';
import InformacoesView from '@/views/InformacoesView.vue';
import ArtigoView from '@/views/ArtigoView.vue';

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/quem-somos",
    name: "QuemSomos",
    component: QuemSomosView,
  },
  {
    path: "/exames",
    name: "Exames",
    component: ExamesView,
  },
  {
    path: "/eventos",
    name: "Eventos",
    component: EventosView,
  },
  {
    path: "/blog",
    name: "Blog",
    component: BlogView,
  },
  {
    path: "/artigos",
    name: "Artigos",
    component: ArtigosView,
  },
  {
    path: "/galeria",
    name: "Galeria",
    component: GaleriaView,
  },
  {
    path: "/contato",
    name: "Contato",
    component: ContatoView,
  },
  {
    path: "/exame-detalhe",
    name: "ExameDetalhe",
    component: ExameDetalheView,
  },
  {
    path: "/blog/:id/:slug?",
    name: "BlogDetalhe",
    component: ArtigoView,
  },  {
    path: '/informacoes/:id?/:slug?',
    name: 'Informacoes',
    component: InformacoesView,
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0 };
  },
});

export default router;
